/**
 * SEO优化评分和合规检查展示组件
 */

import React from 'react';
import { Card, Space, Typography } from 'antd';
import {
    SafetyCertificateOutlined,
    BulbOutlined,
} from '@ant-design/icons';
import { useSEOAnalysisPanel } from './hooks/useSEOAnalysisPanel';
import { SEOScoreOverview } from './SEOAnalysisPanelComponents/SEOScoreOverview';
import { ComplianceAlert } from './SEOAnalysisPanelComponents/ComplianceAlert';
import { CharCheck } from './SEOAnalysisPanelComponents/CharCheck';
import { SearchTermsSuggestion } from './SEOAnalysisPanelComponents/SearchTermsSuggestion';

const { Text } = Typography;

interface SEOAnalysisPanelProps {
    title: string;
    bulletPoints: string[];
    keywords: string[];
}

export const SEOAnalysisPanel: React.FC<SEOAnalysisPanelProps> = ({
    title,
    bulletPoints,
    keywords,
}) => {
    const {
        seoScore,
        complianceIssues,
        titleCharCheck,
        bulletCharChecks,
        backendSearchTerms,
        scoreLevel,
    } = useSEOAnalysisPanel({
        title,
        bulletPoints,
        keywords
    });

    return (
        <Card
            size="small"
            title={
                <Space>
                    <SafetyCertificateOutlined />
                    <span>SEO优化分析</span>
                </Space>
            }
            style={{ marginBottom: 16 }}
        >
            {/* 总评分 */}
            <SEOScoreOverview seoScore={seoScore} scoreLevel={scoreLevel} />

            {/* 合规问题 */}
            <ComplianceAlert issues={complianceIssues} />

            {/* 字符数检查 */}
            <CharCheck titleCharCheck={titleCharCheck} bulletCharChecks={bulletCharChecks} />

            {/* 优化建议 */}
            {seoScore.suggestions.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <Text strong><BulbOutlined /> 优化建议:</Text>
                    <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 20 }}>
                        {seoScore.suggestions.map((suggestion, idx) => (
                            <li key={idx}>
                                <Text type="secondary">{suggestion}</Text>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* 后台搜索词建议 */}
            <SearchTermsSuggestion terms={backendSearchTerms} />
        </Card>
    );
};

export default SEOAnalysisPanel;
